module.exports = __webpack_public_path__ + "static/img/banner.bc5f39fe.jpg";